class WelanteController {

    constructor() {
        this.modal = document.querySelector('#welantecontainer');
        this.searchField = document.querySelector('.welante-list .search-input input');
        this.filterSelects = document.querySelectorAll('.welante-list .filter select');
        this.resetButton = document.querySelector('.reset-search');
        this.orderButton = document.querySelector('.welante-course-book');
        this.modalBackdrop = document.querySelector('.modal-backdrop');
        this.addEventListeners();
    }

    addEventListeners() {
        document.addEventListener('DOMContentLoaded', () => {

            document.addEventListener('click', this.handleErrors.bind(this));
            document.addEventListener('click', this.handleDelegatedClicks.bind(this));

            if (this.searchField && this.filterSelects && this.resetButton) {
                this.resetButton.addEventListener('click', this.resetFilter.bind(this));
            }

            if (this.orderButton) {
                this.orderButton.addEventListener('click', this.showModal.bind(this));
            }

            if (this.modalBackdrop) {
                this.modalBackdrop.addEventListener('click', this.hideModal.bind(this));
            }
        });
    }

    resetFilter() {
        this.searchField.value = '';
        window.location.href = window.location.href.split('?')[0];
        this.filterSelects.forEach((select) => {
            select.selectedIndex = 0;
        });
    }

    showModal() {
        this.modal.classList.add('show');
        document.body.classList.add('modal-open');
    }

    hideModal() {
        if (this.modal) {
            this.modal.classList.remove('show');
            document.body.classList.remove('modal-open');
        }
    }

    handleErrors(event) {
        if (this.modal && event.target.tagName === 'BUTTON' && this.modal.contains(event.target)) {
            setTimeout(() => {
                if (this.modal.querySelectorAll('.error').length > 0) {
                    this.modal.querySelector('.error').scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
                }
            }, 500);
        }
    }

    handleDelegatedClicks(event) {
        if (this.modal && event.target.tagName === 'H2' && this.modal.contains(event.target)) {
            this.hideModal();
        }
    }
}

welante = new WelanteController();

class InfoBox {
    constructor() {
      this.bindEvents();
    }
    
    bindEvents() {
      let infoBoxButtons = document.querySelectorAll('.event-infobox button');
      if (infoBoxButtons) {
          infoBoxButtons.forEach((infoBox) => {
          infoBox.addEventListener('click', (event) => {
            event.target.closest('.event-infobox').classList.toggle('open');
          });
        });
      }
    }
  }
  const infoBoxHandler = new InfoBox();